var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.506,
    height: 33.251,
    viewBox: "0 0 47.506 33.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-coffee",
    "data-name": "Icon awesome-coffee",
    d: "M14.251,28.376H28.5a7.127,7.127,0,0,0,7.125-7.125H38a9.5,9.5,0,1,0,0-19H8.907A1.777,1.777,0,0,0,7.125,4.031V21.251A7.127,7.127,0,0,0,14.251,28.376ZM38,7a4.75,4.75,0,1,1,0,9.5H35.627V7Zm3.54,28.5H3.585c-3.533,0-4.528-4.75-2.672-4.75H44.207c1.856,0,.876,4.75-2.665,4.75Z",
    transform: "translate(0.004 -2.25)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffe);
export default __webpack_public_path__ + "static/media/coffe.145e1eee9d54cd394ccdf57a5359e32f.svg";
export { ForwardRef as ReactComponent };